import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule  } from '@angular/Common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { CoppaDobValidatorDirective } from "./coppa-dob.directive";
import { MinAgeDobValidatorDirective } from "./min-age-dob.directive";
import { DobValidatorDirective } from "./valid-dob.directive";
import { DynamicRequiredValidatorDirective } from "./dynamic-required.directive";
import { DoesEmailExistValidatorDirective } from "./email-exists.directive";
import { ConfirmValueValidatorDirective } from "./confirm-value.directive"; 
import { DisallowedWordsValidatorDirective } from "./disallowed-words.directive";
import { DoesAccountNameExistValidatorDirective } from "./account-name-exists.directive";
import { RegexPatternDirective } from "./regex-pattern.directive";
import { RegexMatchDirective } from "./regex-match.directive";
import { MinimumLengthValidatorDirective } from "./minimum-length.directive";
import { IsNumberValidatorDirective } from "./is-number.directive";
import { IsIntegerValidatorDirective } from './is-integer.directive';
import { IntegerBetweenValidatorDirective } from './integer-between.directive';
import { EmailSuggestionValidatorDirective } from "./email-suggestion-directive";
import { MaxFileSizeDirective } from "./max-file-size.directive";
import { FileExtensionDirective } from "./file-extenstion.directive";
import { MaxWordsDirective } from "./max-words.directive";
import { MinimumDateDirective} from "./date/minimum-date.directive";
import { MaximumDateDirective} from "./date/maximum-date.directive";
import { IsSiteDirective} from "./is-site.directive";

import { ValidationService } from "../../core/custom-validation/services/validation.service";


@NgModule({

    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        HttpClientJsonpModule,
        ReactiveFormsModule,
    ],
    declarations: [ 
        
        CoppaDobValidatorDirective,
        DobValidatorDirective,
        DynamicRequiredValidatorDirective,
        DoesEmailExistValidatorDirective,
        ConfirmValueValidatorDirective,
        DisallowedWordsValidatorDirective,
        DoesAccountNameExistValidatorDirective,
        RegexPatternDirective, 
        RegexMatchDirective,
        MinimumLengthValidatorDirective,
        IsNumberValidatorDirective,
        EmailSuggestionValidatorDirective,
        IsIntegerValidatorDirective,
        IntegerBetweenValidatorDirective,
        MaxFileSizeDirective,
        FileExtensionDirective,
        MaxWordsDirective,
        MinimumDateDirective,
        MaximumDateDirective,
        MinAgeDobValidatorDirective,
        IsSiteDirective

    ],
    providers: [ValidationService,
        { provide: LocationStrategy, useClass: HashLocationStrategy }],
    exports: [
        
        CoppaDobValidatorDirective,
        DobValidatorDirective,
        DynamicRequiredValidatorDirective,
        DoesEmailExistValidatorDirective,
        ConfirmValueValidatorDirective,
        DisallowedWordsValidatorDirective,
        DoesAccountNameExistValidatorDirective,
        RegexPatternDirective, 
        RegexMatchDirective,
        MinimumLengthValidatorDirective,
        IsNumberValidatorDirective,
        EmailSuggestionValidatorDirective,
        IsIntegerValidatorDirective,
        IntegerBetweenValidatorDirective,
        MaxFileSizeDirective,
        FileExtensionDirective,
        MaxWordsDirective,
        MinimumDateDirective,
        MaximumDateDirective,
        MinAgeDobValidatorDirective, 
        IsSiteDirective
    ]
})
export class ValidationModule {

}